// Index of SVG graphics goes here so we don't have to clutter the main component
import { ReactComponent as MagnifyMinus } from "./magnify-minus.svg";
import { ReactComponent as MagnifyPlus } from "./magnify-plus.svg";
import { ReactComponent as Checkmark } from "./check-solid.svg";
import { ReactComponent as Summer } from "./summer.svg";
import { ReactComponent as ExtendedSummer } from "./extended-summer.svg";
import { ReactComponent as Fall } from "./fall.svg";
import { ReactComponent as Winter } from "./winter.svg";
import { ReactComponent as MoreImages } from "./more-images.svg";

const iconTypes = {
  magnifyMinus: MagnifyMinus,
  magnifyPlus: MagnifyPlus,
  checkmark: Checkmark,
  summer: Summer,
  extendedSummer: ExtendedSummer,
  fall: Fall,
  winter: Winter,
  moreImages: MoreImages,
};

export default iconTypes;
